<template lang="">
    <div  class="notolao" >
        <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
            <b-navbar-brand href="#">
                <b-icon   icon="person-square"></b-icon> ຜູ້ໃຊ້ງານ </b-navbar-brand>
                 <b-navbar-nav class="ml-auto">
                 <!-- <b-nav-item-dropdown right>
                           
                            <template #button-content>
                                ພາສາ
                            </template>
                        <b-dropdown-item href="#">LA</b-dropdown-item>
                        <b-dropdown-item href="#">EN</b-dropdown-item>
                    </b-nav-item-dropdown>   -->

                <b-nav-item @click="goback()" > 
                    <b-icon icon="x-lg" aria-hidden="true" variant="light"></b-icon>
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
        <div class=" p-3">
            <b-card>
                <b-table striped hover :items="items" :fields="fields">
    
                    <template #cell(action)="data">
                                        <b-button variant="outline-success" @click="Openformuser"> {{$t("button.add")}}  </b-button>  
                                        <b-button variant="outline-primary" @click="onEdit(data.item)" > {{$t("button.edit")}}   </b-button>  
                                         <b-button variant="outline-danger"  @click="del(data.item.username)"> {{$t("button.delete")}}   </b-button>    
                                          {{data.item.userid}}
</template>
                </b-table>
            </b-card>
        </div>
    
    
        <b-modal ref="user-modal"  hide-footer :title=" $t('users.title') ">
             <b-form  class="notolao"  @submit="onSubmit" >
                <b-form-group  :label="$t('users.username')" label-cols="4" >
                    <b-form-input
                   
                    v-model="fld.username"
                    placeholder=""
                    required
                    ></b-form-input>
                </b-form-group>

               

                <b-form-group  :label="$t('users.password')" label-cols="4"  >
                    <b-form-input
                   
                    v-model="fld.password"
                    type="password"
                    placeholder=""
                    required
                    ></b-form-input>
                </b-form-group>
                <b-form-group  :label="$t('users.fullname')" label-cols="4" >
                    <b-form-input
                   
                    v-model="fld.fullname"
                    placeholder=""
                    required
                    ></b-form-input>
                </b-form-group>

                <b-form-group  :label="$t('users.org_type_code')"  label-cols="4" >
                   <b-form-select
                    v-model="fld.org_type_code"
                    :options="org_type"
                    required
                  ></b-form-select>
                </b-form-group>

                <b-form-group  :label="$t('users.user_level')"  label-cols="4" >
                   <b-form-select
                    v-model="fld.user_level"
                    :options="levels"
                    required
                  ></b-form-select>
                </b-form-group>

                <b-form-group  :label="$t('users.branch_id')" label-cols="4"    >
                     
                    <b-form-select   disabled-field="disabled"
                    v-model="fld.prov_id"
                    :options="branchs"
                      @input="getDep"
                  ></b-form-select>
                </b-form-group>

                <b-form-group  :label="$t('users.dep_code')"    label-cols="4" >
                     
                    <b-form-select  readonly
                    v-model="fld.district_id"
                    :options="dep"
                     
                      @input="getscholls"
                     @change="getscholls"
                  ></b-form-select>
                </b-form-group>

                <b-form-group  :label="$t('users.scholl')"  label-cols="4" >
                     
                     <b-form-select
                     v-model="fld.school_id"
                     :options="schools"
                      
                   ></b-form-select>
                 </b-form-group>
                 <b-form-group  :label="$t('users.Active')"  label-cols="4" >
                     
                     <b-form-select
                     v-model="fld.active"
                     :options="Active"
                     required
                   ></b-form-select>
                 </b-form-group>

                <b-button block  type="submit" variant="outline-primary"> {{$t('button.save')}} </b-button>
              
             </b-form>
        </b-modal>
 
    
    </div>
</template>

<script>
import axios from "axios";

export default {
    watch: {},
    props: {},
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
      this.fld.prov_id=  this.user.district_id.substring(0, 2)
      this.fld.district_id=this.user.district_id
        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/users_district/"+this.user.district_id,
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.items = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });

            this.getDep()
            this.getscholls()


        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/levels/level_desc/level_id",
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.levels = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });

            axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/org_type/org_type_desc/org_type_code",
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.org_type = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });

        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/province/prov_name/prov_id",
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.branchs = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });

    },
    data() {
        return {
            branchs:[],
            dep:[],
            fields: [

                {
                    label: this.$t('users.username'),
                    key: "username",
                    thStyle: { background: "#023c7e", color: "#ffffff" },
                },
                {
                    label: this.$t('users.email'),
                    key: "email",
                    thStyle: { background: "#023c7e", color: "#ffffff" },
                },
                {
                    label: this.$t('users.fullname'),
                    key: "fullname",
                    thStyle: { background: "#023c7e", color: "#ffffff" },
                },
                {
                    label: this.$t('users.province_name'),
                    key: "prov.prov_name",
                    thStyle: { background: "#023c7e", color: "#ffffff" },
                },
                {
                    label: this.$t('users.user_level'),
                    key: "user_level",
                    thStyle: { background: "#023c7e", color: "#ffffff" },
                },
                {
                    label: this.$t('users.level_desc'),
                    key: "level.level_desc",
                    thStyle: { background: "#023c7e", color: "#ffffff" },
                },
                {
                    label: "#ເຫດການ#",
                    key: "action",
                    thStyle: { background: "#023c7e", color: "#ffffff" },
                    thClass: "text-right  ",
                    tdClass: "text-right  ",
                },

            ],
            items: [],
            fld: {
                "id": "",
                "username": "",
                "email": "",
                "password": "",
                "employee_id": "",
                "default_module": "",
                "user_level": "",
                "user_roles": "",
                "last_login": "",
                "last_update": "",
                "created": "",
                "login_hash": "",
                "lang": "",
                "border_id": "",
                "prov_id": "",
                "district_id":"",
                "school_id":"",
                "fullname":"",
                "org_type_code":"",
                "Active":1
                
            },
            levels: [],
            provices: [],
            borders: [],
            schools:[],
            org_type:[],
            teacher_role:[],
            Active:[
              {  value:1, text:"Yes"}, {  value:0, text:"No"},

            ]
        }
    },
    methods: {
        goback() {
            this.$router.go(-1)
        },
        Openformuser() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['user-modal'].show()
        },
        getDep() {
            //getItemsCondition
            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/district/district_name_lao/district_id/prov_id/" + this.fld.prov_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.dep = response.data;
                    //    console.log(  JSON.parse(response.data))
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        onSubmit(event) {
             event.preventDefault()
            let data ={
                item: this.fld
            }
            axios
                .post(this.$store.getters.getBaseUrl + "/adduser", data, {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash,
                        "Content-Type": "application/json"
                    }
                 
                })
                .then((response) => {
                    //     console.log("response: ", response.data);
                    console.log(response.data.desc)
                    if(response.data.code=="1"){
                        this.$bvToast.toast("ບັນທຶກສຳເລັດແລ້ວ", {
                        title: `Success:`,
                        toaster: 'b-toaster-top-right',
                        solid: true,
                        appendToast: true
                    })
                    }else{
                        this.$bvToast.toast("ບໍສາມາອັບເດດລາຍການນີ້, ກະລຸນາລອງໃໝ່.", {
                        title: `Error:`,
                        toaster: 'b-toaster-top-right',
                        solid: true,
                        appendToast: true
                    })
                    }
                    
                     this.$refs['user-modal'].hide()

                })
                .catch((err) => {
                    console.error(err);
                    //alert(err)
                    // countDownChanged;
                    
                   
                });

        },
        onEdit(row){
            this.fld=row
            this.$refs['user-modal'].show()
        },
        del(code) {

            let params = {
                table: "users",
                pkey: 'username',
                code: code
            }
            this.$bvModal.msgBoxConfirm('ກະລຸນາຢືນຢັນ ທ່ານຕ້ອງການລົບລາຍການນີອອກຈາກລະບົບ.', {
                title: 'Please Confirm',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value == true) {
                        axios.post(this.$store.getters.getBaseUrl + '/deluser', params,{
                            headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                        })
                            .then((res) => {
                                if (res.data.code == 1) {
                                    this.$bvToast.toast(`ລົບລາຍການອອກສຳເລັດແລ້ວ.`, {
                                        title: 'ຂໍ້ຄວາມແຈ້ງກັບ...',
                                        autoHideDelay: 5000,
                                        appendToast: true
                                    })

                                    axios
                                        .get(
                                            this.$store.getters.getBaseUrl + "/dynamic_table/" + this.menuid + "?offset=0&fld=" + this.field + "&find=" + this.find +'&branch_id='+this.user.branch_id,{
                                                headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                                            }
                                        )
                                        .then((response) => {
                                            // JSON responses are automatically parsed.
                                            this.pkey = response.data.pkey
                                            this.table = response.data.table
                                            this.fields = JSON.parse(response.data.fields)
                                            this.items = response.data.items
                                            this.fields.forEach((item) => {
                                                this.findfied.push({
                                                    value: item.key,
                                                    text: item.label
                                                })
                                            })

                                        })
                                        .catch((e) => {
                                            console.log(e);
                                        });

                                    this.page = 0

                                } else {
                                    this.$bvToast.toast(res.data.msg, {
                                        title: 'ຂໍ້ຄວາມແຈ້ງກັບ...',
                                        autoHideDelay: 5000,
                                        appendToast: true
                                    })



                                }
                                console.log(res.data)
                            })
                            .catch(err => {

                                console.error(err);
                            })
                    }
                    //this.boxTwo = value
                })
                .catch(err => {
                    console.error(err);
                })

        },
        getscholls(){
            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/schools/school_name_lao/school_id/district_id/" + this.fld.district_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.schools = response.data;
                   //   console.log(  JSON.parse(this.scholls))
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    },

}
</script>

<style scoped>
.content {
    margin-top: 80px;
}

.notolao {
    font-family: 'Noto Sans Lao Regular', 'Phetsarath OT';
}
</style>